(() => {
  const openCartParameter = 'open_cart_drawer';
  const lastStorefrontKey = 'lbr:last-storefront-url';
  const currentUrl = new URL(window.location.href);

  const saveLastStorefrontUrl = (url) => {
    try {
      window.sessionStorage.setItem(lastStorefrontKey, url);
    } catch (_error) {
      // The redirect still works with the localized homepage fallback.
    }
  };

  const shouldOpenCartDrawer = currentUrl.searchParams.get(openCartParameter) === '1';
  currentUrl.searchParams.delete(openCartParameter);
  const cleanStorefrontUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
  saveLastStorefrontUrl(cleanStorefrontUrl);

  if (!shouldOpenCartDrawer) return;

  window.history.replaceState({}, '', cleanStorefrontUrl);

  let attempts = 0;
  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer();
      return;
    }

    attempts += 1;
    if (attempts < 100) window.setTimeout(openCartDrawer, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartDrawer, { once: true });
  } else {
    openCartDrawer();
  }
})();
